/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/
import React from 'react'
import { Routes, Route } from 'react-router-dom'


import ErrorPage from './public/ErrorPage'
import HomePage from './public/HomePage'
import LoginPage from './public/LoginPage'
import NotFoundPage from './public/NotFoundPage'
import AboutPage from './public/AboutPage'
import FAQPage from './public/FAQPage'
import TOSPage from './public/TOSPage'
import PrivacyPolicyPage from './public/PrivacyPolicyPage'
import CustomSolutionsPage from './public/CustomSolutionsPage'
import DigitalAssetsPage from './public/DigitalAssetsPage'
import EnterprisePage from './public/EnterprisePage'
import HistoryPage from './public/HistoryPage'
import ContactUsPage from './public/ContactUsPage'
import useGaTracker from './useGaTracker'
import AIPage from './public/AIPage'



const Pages = () => {
  useGaTracker();

  return (
    <Routes>
      <Route exact path={"/"} element={
        <HomePage />
      } />

      <Route exact path={"/faq"} element={
        <FAQPage />
      } />
      <Route exact path={"/home"} element={
        <HomePage />
      } />
      <Route exact path={"/login"} element={
        <LoginPage />
      } />

      <Route exact path={"/about"} element={
        <AboutPage />
      } />
      <Route exact path={"/tos"} element={
        <TOSPage />
      } />
      <Route exact path={"/privacypolicy"} element={
        <PrivacyPolicyPage />
      } />

      <Route exact path={"/customsolutions"} element={
        <CustomSolutionsPage />
      } />
      <Route exact path={"/artificialintelligence"} element={
        <AIPage />
      } />
      <Route exact path={"/digitalassets"} element={
        <DigitalAssetsPage />
      } />
      <Route exact path={"/enterprise"} element={
        <EnterprisePage />
      } />

      <Route exact path={"/history"} element={
        <HistoryPage />
      } />
      <Route exact path={"/contact"} element={
        <ContactUsPage />
      } />

      <Route exact path={"/error*"} element={
        <ErrorPage />
      } />
      <Route element={NotFoundPage} />
    </Routes>


  )
}

export default Pages
